import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceCity from "@/views/系统设置/service/DZServiceCity";
import dzMsgBox from "@/utils/DZMessageBox";
import nyMessageToast from "@/utils/NYMessageToast";

@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    s_city = new DZServiceCity();

    created() {
        this.action_page_city()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    bindStatus(status){
        if(status == 0){
            return "正常"
        }else if(status == 1){
            return "已冻结"
        }
    }

    bindLevel(level){
        if(level == 1){
            return "省级"
        }else if(level == 2){
            return "市级"
        }else if(level == 3){
            return "区县"
        }
    }

    handle_open(){
        this.$router.push({ path: "/setting/cityList" })
    }

    handle_operate_city(row){
        let msg = ""
        if(row.status == 0){
            msg = "冻结"
        }else if(row.status == 1){
            msg = "解冻"
        }else{
            return
        }
        dzMsgBox.change("确定"+msg+"<"+row.cityName+">吗",()=>{
            this.s_city.net_operate_city(row.id,this.action_page_city)
        },null)
    }

    action_page_city(){
        this.s_city.net_city_list()
    }

    handle_del_city(row){
        dzMsgBox.change("确定关闭<"+row.name+">吗",()=>{
            this.s_city.net_del_city(row.id,this.action_page_city)
        },null)
    }

    handle_edit_city(row){
        dzMsgBox.prompt("请输入<"+row.name+">二级域名",row.sld,(input)=>{
            if(input.value == "" || input.value.trim() == ""){
                nyMessageToast.error("二级域名不能为空")
                return
            }
            this.s_city.net_edit_city(row.id,input.value,this.action_page_city)
        })
    }

    handle_edit_name(row){
        dzMsgBox.prompt("修改<"+row.name+">名称",row.name,(input)=>{
            if(input.value == "" || input.value.trim() == ""){
                nyMessageToast.error("城市名称不能为空")
                return
            }
            this.s_city.net_edit_cityName(row.id,input.value,this.action_page_city)
        })
    }
}